import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const MicrosoftCosmosDbReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="microsoftCosmosDbReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormDatabaseId"
        label="databaseId"
        name="properties.databaseId"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Database Id"
        error={errors?.properties?.databaseId?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormCollectionId"
        label="collectionId"
        name="properties.collectionId"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Collection Id"
        error={errors?.properties?.collectionId?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormAccountKey"
        label="accountKey"
        name="properties.accountKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter Account Key"
        error={errors?.properties?.accountKey?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormAccountEndpoint"
        label="accountEndpoint"
        name="properties.accountEndpoint"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Account Endpoint URL"
        error={errors?.properties?.accountEndpoint?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormConsistencyLevel"
        label="consistencyLevel"
        name="properties.consistencyLevel"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Consistency Level"
        error={errors?.properties?.consistencyLevel?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormPageSize"
        label="pageSize"
        name="properties.pageSize"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Page Size"
        error={errors?.properties?.pageSize?.message}
      />
      <FormField
        controlId="microsoftCosmosDbReaderFormQuery"
        label="query"
        name="properties.query"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        placeholder="Enter Query"
        required
        rows={10}
        error={errors?.properties?.query?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default MicrosoftCosmosDbReaderForm;
